import axios, {AxiosInstance, AxiosResponse, CreateAxiosDefaults, InternalAxiosRequestConfig} from 'axios';
import config from "../config";

const apiClient: AxiosInstance = axios.create({
    baseURL: `${config.api.baseUrl}`,
    //baseURL: 'http://localhost:3000',
    //baseURL: 'https://seemeworking.com:3066',
    timeout: 1000000,
    withCredentials: false,
    headers: {
        'Content-Type': 'application/json',
        'Access-Control-Allow-Origin':'*'
    },
} as CreateAxiosDefaults);

// Интерсептор для добавления токена в заголовки
apiClient.interceptors.request.use(
    (config: InternalAxiosRequestConfig) => {
        const token = localStorage.getItem('access_token');

        if (token) {
            // Получаем путь URL без параметров и trailing slash
            const pathSegment = config.url?.split('?')[0].replace(/\/$/, '') || '';

            // Проверяем, что запрос не к эндпоинту /login
            if (pathSegment !== '/auth/login') {
                config.headers.Authorization = `Bearer ${token}`;
            }
        }

        return config;
    },
    (error: any) => {
        return Promise.reject(error);
    }
);

apiClient.interceptors.response.use(
    (response: AxiosResponse) => response,
    (error) => {
        if (error.response?.status === 401 || error.response?.status === 403) {
            window.location.href = '/login';
        }
        return Promise.reject(error);
    }
);

export default apiClient;
